<template>
  <div>
    <label
      :for="name"
      class="block text-sm font-medium"
      :class="readonly ? 'text-gray-500' : 'text-gray-700'"
    >
      {{ label }}
    </label>
    <div class="relative mt-1 rounded-md shadow-sm">
      <input
        v-if="!readonly"
        :id="`${name}-input`"
        ref="field"
        v-model="modelValue"
        :name="name"
        :type="type"
        :max="max"
        :min="min"
        :class="{
          'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 ':
            validation.$error || errors.length > 0,
          'placeholder-gray-400 border-gray-300 focus:ring-teal-500 focus:border-teal-500':
            !validation.$error || errors.length === 0,
        }"
        :autocomplete="autocomplete"
        class="block w-full px-3 py-2 bg-white border rounded-md shadow-sm appearance-none focus:outline-none sm:text-sm"
      >
      <div
        v-else
        class="block w-full px-3 py-2 text-gray-400 bg-gray-50 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none sm:text-sm focus:ring-teal-500 focus:border-teal-500"
      >
        {{ modelValue }}
      </div>
      <div
        v-if="validation.$error"
        class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
      >
        <!-- Heroicon name: solid/exclamation-circle -->
        <ExclamationCircleIcon
          class="w-5 h-5 text-red-500"
          aria-hidden="true"
        />
      </div>
    </div>
    <ul
      v-if="validation.$error || errors.length > 0"
      :id="`${name}-error`"
      class="mt-2 text-sm text-red-600"
    >
      <li
        v-for="error in validation.$errors"
        :key="error.$message"
        class="mt-1 capitalize"
      >
        {{ error.$message }}
      </li>
      <li
        v-for="error in errors"
        :key="error"
        class="mt-1 capitalize"
      >
        {{ error }}
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import { ExclamationCircleIcon } from '@heroicons/vue/solid'
const props = withDefaults(
  defineProps<{
    label: string
    name?: string
    autocomplete?: string
    readonly?: boolean
    max?: number
    min?: number
    type?: string
    errors?: string[]
    validation?: any
  }>(),
  {
    name: () => undefined,
    autocomplete: () => undefined,
    max: () => undefined,
    min: () => undefined,
    readonly: () => false,
    type: 'text',
    errors: () => [],
    validation: () => ({ $dirty: false, $error: false }),
  },
)
// const emit = defineEmits<{}>()
const modelValue = defineModel<string | number>()
const field = ref(null)
defineExpose({ field })
// input(input: any) {
//       this.$emit('update:modelValue', input.target.value)
//     },
</script>
